import { PropsWithChildren, FC, useState } from 'react'
import { Modal } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'

import Box from '~/core/Box'
import Button from '~/core/Button'
import Text from '~/core/Text'
import colors from '~/styles/_colors.css'
import getColor from '~/lib/getColor'

import { BUTTON_TITLE, MODAL_BODY_MESSAGES, MODAL_TITLES } from './constants'

const PLACEMENT = 'job-details-header'

type AutoExceptionModalProps = {
    visible: boolean
    handleDone: () => void
    handleCancel: () => void
    actionType: string
}

const AutoExceptionModal: FC<PropsWithChildren<AutoExceptionModalProps>> = ({
    visible,
    actionType,
    handleDone,
    handleCancel,
}) => {
    const [loading, setLoading] = useState(false)

    const handleSubmit = () => {
        setLoading(true)
        handleDone()
        setLoading(false)
    }

    return (
        <Modal
            destroyOnClose={true}
            visible={visible}
            width={602}
            onCancel={handleCancel}
            footer={[
                <Button
                    key="cancel"
                    onClick={(evt: Event) => {
                        evt.stopPropagation()
                        handleCancel()
                    }}
                    placement={PLACEMENT}
                    name="cancel"
                    disabled={loading}
                    data-test-target="cancel-modal-button"
                >
                    Cancel
                </Button>,
                <Button
                    type="primary"
                    key="job-exception-modal"
                    htmlType="submit"
                    placement={PLACEMENT}
                    className={colors.success}
                    name="reject-job-request"
                    loading={loading}
                    data-test-target="resume-pause-exception-button"
                    onClick={(evt: Event) => {
                        evt.stopPropagation()
                        handleSubmit()
                    }}
                >
                    {BUTTON_TITLE[actionType]}
                </Button>,
            ]}
        >
            <Box marginBottom="16px">
                <QuestionCircleOutlined
                    style={{
                        color: getColor('warning'),
                        fontSize: '18px',
                        paddingRight: '20px',
                        paddingTop: '5px',
                    }}
                />
                <Text fontWeight={500} fontSize="18px">
                    {`${MODAL_TITLES[actionType]}`}
                </Text>
            </Box>
            <Box direction="col">
                <Text
                    style={{
                        paddingLeft: '38px',
                    }}
                >
                    {`${MODAL_BODY_MESSAGES[actionType]}`}
                </Text>
            </Box>
        </Modal>
    )
}

export default AutoExceptionModal
